import { Linkedin, Twitter, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import Logo from "@/components/Logo";

export default function Footer() {
  const { t } = useLang();
  const nav = [
    { to: "/projet", key: "nav.about" },
    { to: "/technique", key: "nav.technical" },
    { to: "/impact", key: "nav.esg" },
    { to: "/suivi", key: "nav.monitoring" },
    { to: "/contact", key: "nav.contact" },
  ];
  return (
    <footer className="bg-slate-950 text-white pt-20 pb-10 noise-bg">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid md:grid-cols-4 gap-12">
          <div className="md:col-span-2">
            <Logo dark />
            <p className="text-slate-400 mt-5 max-w-sm leading-relaxed">{t("footer.tagline")}</p>
            <div className="flex gap-3 mt-6">
              {[Linkedin, Twitter, Mail].map((Icon, i) => (
                <a key={i} href="mailto:contact@horizon-affaires-senegal.com" className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center hover:bg-white/10 transition-colors duration-200" data-testid={`social-${i}`}>
                  <Icon className="w-4 h-4 text-slate-300" />
                </a>
              ))}
            </div>
          </div>
          <div>
            <div className="mono text-xs tracking-widest uppercase text-slate-500 mb-4">{t("footer.links")}</div>
            <ul className="space-y-3">
              {nav.map((n) => (
                <li key={n.to}><Link to={n.to} className="text-slate-300 hover:text-sky-400 transition-colors duration-200 text-sm">{t(n.key)}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <div className="mono text-xs tracking-widest uppercase text-slate-500 mb-4">{t("footer.contact")}</div>
            <ul className="space-y-3 text-sm text-slate-300">
              <li>contact@horizon-affaires-senegal.com</li>
              <li>+39 366 728 8052</li>
              <li>Dakar, Sénégal</li>
            </ul>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4 text-sm text-slate-500">
          <span>© {new Date().getFullYear()} Horizon Affaires Senegal. {t("footer.rights")}</span>
          <div className="flex gap-6">
            <Link to="/contact" className="hover:text-slate-300 transition-colors">{t("footer.privacy")}</Link>
            <Link to="/contact" className="hover:text-slate-300 transition-colors">{t("footer.terms")}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
